/* jshint loopfunc:true */
define('plugins/richtext/ckeditorConfig',[], function () {

    'use strict';

    return {
        customConfig : '',
        filebrowserBrowseUrl : 'dummylocation',
        skin : 'moono',
        allowedContent : true
    };

});

